import { useEffect, useRef, useState } from "react"
import Header from "../../components/custom/header"
import "./index.css"
import User from "./user"
import Bubble from "../../components/holders/bubble"
import store from "../../store"
import { toast } from "react-toastify"
import { useGlobal } from '../../context/global'
import DP from "../../components/custom/dp"

const Users = () => {

    const { auth, api } = useGlobal()

    var [users, setUsers] = useState()
    var [filter, setFilter] = useState()
    var [showUserActions, setShowUserActions] = useState(false)
    var [selectedUser, setSelectedUser] = useState()

    var timerID = useRef()

    useEffect(() => {
        api.call('/get-users').then(r => {
            setUsers(r.data)
        }).catch(err => {
            console.log(err)
        })
    }, [api])

    const handleInput = (e) => {
        clearTimeout(timerID.current)
        timerID.current = setTimeout(() => {
            setFilter(e.target.value)
        }, 300)
    }

    const handleUserClick = (user) => {
        setSelectedUser(user)
        setShowUserActions(true)
    }

    const hideUserActions = () => {
        setShowUserActions(false)
    }

    const handleCustomLogin = () => {
        const newUser = users.find(user => {
            return String(user.id) === String(selectedUser.id) && String(user.roleID) === String(selectedUser.roleID)
        })

        if (newUser) {
            if (String(newUser.id) === String(auth.user.id) && String(newUser.roleID) === String(auth.user.roleID)) {
                toast.warn("You are already logged in as the same user!")
                return
            }

            const existingIndex = auth.users.findIndex(u => String(u.id) === String(newUser.id) && String(u.roleID) === String(newUser.roleID))
            let newUsers = [...auth.users]
            let targetIndex
            if (existingIndex !== -1) {
                targetIndex = existingIndex
            } else {
                newUsers.push(newUser)
                targetIndex = newUsers.length - 1
            }

            store.set({
                index: targetIndex,
                users: newUsers
            }).then(() => {
                window.open("/home", "_self")
            }).catch(error => {
                toast.error(error)
            })
        }
    }

    return (
        <div className="users-root">
            <Header title={"Users"} />
            <div className="users-main">
                {showUserActions ?
                    <Bubble dark onClose={hideUserActions}>
                        <div className="users-actions-modal">
                            <div className="users-actions-header">
                                <h3>Account Options</h3>
                            </div>
                            <div className="users-actions-profile">
                                <DP user={selectedUser} size={15} className="users-actions-dp" />
                                <div className="users-actions-details">
                                    <div className="users-actions-name">{selectedUser.initiationName || selectedUser.name}</div>
                                    <div className="users-actions-role">{selectedUser.roleName}</div>
                                </div>
                            </div>
                            <div className="users-actions-buttons">
                                <button className="users-actions-btn login-btn" onClick={handleCustomLogin}>
                                    {`Login As ${selectedUser.name}`}
                                </button>
                                <button className="users-actions-btn cancel-btn" onClick={hideUserActions}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Bubble>
                    : null}
                <input onChange={handleInput} className="users-filter" placeholder="Start typing user name..." />
                {users ? <div>
                    {
                        users.map(user => {
                            return (
                                <User
                                    key={`${user.id}-${user.roleID}`}
                                    user={user}
                                    hide={filter && !user.name.toLowerCase().includes(filter.toLowerCase())}
                                    onClick={handleUserClick}
                                />
                            )
                        })
                    }
                </div> : null}
            </div>
        </div>
    )
}

export default Users